require('./brokerView.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');

const brokerPositionsValuesContractsActions = require('actions/brokerPositionsValuesContracts');

class BrokerView extends React.Component {

    componentDidMount() {
       this.props.populateContractDescriptions();
    }

    render() {
        return (
            <div className="broker-view">
                <section className="broker-view__content">
                    {this.props.children}
                </section>
            </div>
        );
    }
}


BrokerView.propTypes = {
    children: PropTypes.object,
    populateContractDescriptions: PropTypes.func,
    checkPersonalInformationData: PropTypes.func,
    immbrokerClientWarningModal: PropTypes.object
};

module.exports.constructor = BrokerView;
module.exports.BrokerView = connect(
    state => ({
        brokerState: state.brokerState
    }),{
        populateContractDescriptions: brokerPositionsValuesContractsActions.populateContractDescriptions
    })(BrokerView);